import * as React from 'react';
import { FC, useCallback, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { styled, alpha } from '@mui/material/styles';
import {Button, Drawer, IconButton, Tooltip, Typography} from '@mui/material';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PreviewIcon from '@mui/icons-material/RemoveRedEye';
import DeleteIcon from '@mui/icons-material/Delete';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ShareIcon from '@mui/icons-material/Share';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
// import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import ThermalPrintDialog from '../ThermalPrintDialog/ThermalPrintDialog';

import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { AEstimate } from '../../utils/estimate.types';
import DialogRecievePaymentForm from '../DialogPaymentSettlementForm/DialogRecievePaymentForm';
import { fetchInvoicesWithoutState, updateInvoiceStatus, deleteInvoice, deletePaymentReceipt } from '../../store/invoiceStore/invoiceThunk';
import { deleteVendorPayment,  } from '../../store/CashOutflowStore/cashOutflowThunk';
import DialogShareInvoiceReciept from '../../components/DialogShareInvoiceReciept/DialogShareInvoiceReciept';
import { AInvoice } from '../../utils/invoice.types';
import { Utils, InvoiceRoute, VocuherCategory, VocuherTypes } from "../../utils/common-utils";
import { red } from '@mui/material/colors';
import { toast } from 'react-toastify';

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

interface estimateActionProp {
  type: string;
  row: AEstimate;
  actionChangeHandler?: (data: any) => void;
  showInlineAction?: boolean;
}

const CustomizedEstimateMenus: FC<estimateActionProp> = ({ type, row, actionChangeHandler, showInlineAction}) => {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { permissions, selectedAccount } = useAppSelector(state => state.auth);

  const { accountDetails } = useAppSelector(state => state.account);

  const currentPathName = window.location.href;
  const curPage = currentPathName.split('/');

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [openShareDrawer, setOpenShareDrawer] = useState<boolean>(false);
  const [openRecivePaymentDrawer, setOpenRecivePaymentDrawer] = useState<boolean>(false);
  const [selectedInvoices, setSelectedInvoices] = useState<AEstimate[]>([]);
  const [saleId, setSaleId] = useState<string>(row._id);
  const [saleType, setSaleType] = useState<string>(row.voucherCategory || '');
  const [invoiceType, setInvoiceType] = useState<string>("");
  const [salePdfUrlLocation, setSalePdfUrlLocation] = useState<any>(row.pdfUrlLocation);
  const [selectedBuyer, setSelectedBuyer] = useState<any>();
  const [saleModuleType, setSaleModuleType] = useState<string>(row.voucherType || 'Invoice');
  const [shareType, setShareType] = useState<any>();
  const [isCompRefresh, setIsCompRefresh] = useState(false);

  // const [refresh, setRefresh] = useState<boolean>(true);

  // Thermal print dialog state
  const [thermalPrintOpen, setThermalPrintOpen] = useState(false);
  const [selectedInvoiceForPrint, setSelectedInvoiceForPrint] = useState<AEstimate | null>(null);

  // Open thermal print dialog
  const handleThermalPrint = useCallback((invoice: AEstimate) => {
    setSelectedInvoiceForPrint(invoice);
    setThermalPrintOpen(true);
    handleClose();
  }, []);

  // Generate thermal content (kept for backward compatibility)
  const generateThermalContent = (invoice: AEstimate) => {
    const businessName = selectedAccount?.name || 'Business';
    const businessPhone = selectedAccount?.whatsAppNumber || '';
    const businessAddress = selectedAccount?.location?.address || '';
    
    return `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Thermal Receipt</title>
          <style>
            @page { size: 58mm auto; margin: 2mm; }
            body {
              font-family: monospace;
              font-size: 8pt;
              line-height: 1.2;
              margin: 0;
              padding: 2mm;
              width: 54mm;
            }
            .header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 2mm; margin-bottom: 2mm; }
            .business-name { font-weight: bold; font-size: 10pt; margin-bottom: 1mm; }
            .section { margin-bottom: 2mm; border-bottom: 1px dotted #999; padding-bottom: 1mm; }
            .total { font-weight: bold; text-align: center; padding: 2mm; border: 2px solid #000; margin: 2mm 0; }
            @media print { body { margin: 0; padding: 1mm; } }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="business-name">${businessName}</div>
            ${businessAddress ? <div>${businessAddress}</div> : ''}
            ${businessPhone ? <div>Ph: ${businessPhone}</div> : ''}
            <div>================================</div>
            <div><strong>${invoice.voucherType?.toUpperCase()}</strong></div>
            <div>Bill: ${(invoice as any).invoiceNumber || 'N/A'}</div>
            <div>${new Date().toLocaleDateString('en-IN')} ${new Date().toLocaleTimeString('en-IN')}</div>
          </div>
          
          <div class="section">
            <div><strong>BILL TO:</strong></div>
            <div>${invoice.client?.name || invoice.supplier?.name || 'Customer'}</div>
            ${invoice.client?.phone || invoice.supplier?.phone ? <div>${invoice.client?.phone || invoice.supplier?.phone}</div> : ''}
          </div>
          
          <div class="section">
            <div><strong>ITEMS:</strong></div>
            ${(invoice as any).lineItems?.map((item: any, i: number) => `
              <div style="margin: 1mm 0;">
                <div>${item.description || item.name || 'Item ' + (i + 1)}</div>
                <div>${item.qty || 1} x ${Utils.formatNumber(item.appliedRate || item.rate || 0)} = ${Utils.formatNumber(item.total || 0)}</div>
              </div>
            `).join('') || <div>Service: ${Utils.formatNumber(invoice.amount || 0)}</div>}
          </div>
          
          <div class="total">
            TOTAL: ₹${Utils.formatNumber(invoice.amount || 0)}
          </div>
          
          <div style="text-align: center; margin-top: 2mm; border-top: 2px dashed #000; padding-top: 2mm;">
            <div>Thank You!</div>
            <div>Powered by iBook</div>
          </div>
        </body>
      </html>
    `;
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewInvoiceClick = useCallback(({ _id, status, pdfTemplate, voucherCategory }: AEstimate) => {
    // Call edit function
    let navLink = '';
    let path = 'invoice';
    console.log("============= ", type);
    if (type == 'sale-estimate') {
      path = `estimate`;
    } else if (type == 'sale-credit-note') {
      // TODO: Make Common flow for all moduels for view invoice
      path = `estimate`;
    } else if (type == 'sale-debit-note') {
      path = `estimate`;
    } else if (type == 'sale-delivery-note') {
      path = `delivery-note`;
    }
    // navLink = `/sales/${path}/${_id}/view?templateId=${pdfTemplate}&type=${type}&pdfLocation=${salePdfUrlLocation.Location}`;
    navLink = `/invoice/${_id}/preview?templateId=${pdfTemplate}&type=${voucherCategory}`;
    navigate(navLink);
    // window.open(navLink, '_blank');
  }, []);

  const handleEditInvoiceClick = useCallback(({ _id, status, pdfTemplate, voucherType, voucherCategory }: AEstimate) => {
    // Call edit function
    let navLink = '';
    let type = voucherCategory ? voucherCategory : VocuherCategory.SALE;
    let navEditLink = '';
    console.log(type);
    console.log(voucherType);
    let invoiceMeta = Utils.getInvoiceRouteName(voucherType || '');
    navEditLink = `/${type}/invoice/${invoiceMeta.routeName}/edit/${_id}`
    if (navEditLink != '') navigate(navEditLink);
  }, []);

  // const handleOpenShareDrawer = (event: any) => {
  //   console.log(" OpenShare drawer called");
  //   setSelectedBuyer(row.buyer);
  //   setOpenShareDrawer(true);
  //   event.stopPropagation();
  //   handleClose()
  // };

  const handleOpenShareDrawer = (event: any, shareTypeCheck: string) => {
    console.log("OpenShare drawer called");
    console.log(row);
    setSelectedBuyer(row.client);
    setShareType(shareTypeCheck);
    setSaleId(row._id);
    if ( shareTypeCheck == 'Payment Receipt') {
      console.log(row.receiptPdfUrlLocation);
      setSalePdfUrlLocation(row.receiptPdfUrlLocation);
    } else {
      setSalePdfUrlLocation(row.pdfUrlLocation);
    }
    setOpenShareDrawer(true);
    event.stopPropagation();
    handleClose()
  };

  const handleCloseShareDrawer = () => {
    console.log("====== Debuging handleCloseShareDrawer called =====>");
    setSelectedBuyer('');
    setOpenShareDrawer(false);
    // navigate("/sales/estimate");
    // actionChangeHandler = true;
    console.log("setting up refreshCompOnClose ====>")
    console.log(actionChangeHandler)
  };

  const handleRecievePayment = (event: any) => {
    setOpenRecivePaymentDrawer(true);
    console.log(selectedInvoices);
    event.stopPropagation();
  }

  const handleClosPaymentDrawer = () => {
    setSelectedInvoices([]);
    setOpenRecivePaymentDrawer(false);
    if(actionChangeHandler) {
      actionChangeHandler({ isRefersh: Math.random().toString()});
    }
  };

  const openPaymentDrawer = (e: any, invoiceData: any) => {
    setSelectedBuyer(invoiceData.client);

    setSelectedInvoices([invoiceData])

    let queryString = "filter=" + invoiceData.client._id;
    queryString += "&status=PENDING,PARTIALLY_PAID";
    handleRecievePayment(e);
    setAnchorEl(null);
  };

  const handleViewPaymentReceiptClick = useCallback(({ _id, status, receiptPdfTemplate }: AEstimate) => {
    let navLink = '';
    let type = '';
    if (curPage.includes('account-payable')) {
        type = 'AP';
    } else {
        type = 'AR';
    }

    navLink = `/invoice-payment-receipt/${_id}/view?templateId=${receiptPdfTemplate}&type=${type}`;
    navigate(navLink);
  }, []);

  const handleNewTransaction = (vCategory: string, vType: string, _refInvoiceId: string = '', _refVoucherType='', _copy=false) => {
    let redirectTo = '';
    const invoiceMeta = Utils.getInvoiceRouteName(vType);
    if (vCategory && vType){
        redirectTo = `/${vCategory}/invoice/${invoiceMeta.routeName}/create`;
    }
    if (vCategory && vType && _refInvoiceId != '' && _refVoucherType != '') {
      redirectTo = `/${vCategory}/invoice/${invoiceMeta.routeName}/create?_ref=${_refInvoiceId}&_reftype=${_refVoucherType}&_copy=${_copy}`;
    }
    navigate(redirectTo);
  };

  const handleChangeInvoiceStatus = (invoiceId: string, status: string) => {
    let data = {
      id: invoiceId,
      invoiceStatus: status
    }
    dispatch(updateInvoiceStatus(data))
    if(actionChangeHandler) {
      actionChangeHandler({ isRefersh: Math.random().toString()});
    }
    handleClose()
  };

  // const handleDeleteInvoice = (invoiceId: string) => {
  //   dispatch(deleteInvoice(invoiceId))
  //   if(actionChangeHandler) {
  //     actionChangeHandler({ isRefersh: Math.random().toString()});
  //   }
  //   handleClose()
  // };

  const handleDeleteInvoicePayments = (invoiceId: string, vCategory: string) => {
    console.log("Calling api for vcategory", vCategory, VocuherCategory.SALE)
    if(vCategory == VocuherCategory.SALE) {
      console.log("Calling api for sales");
      dispatch(deletePaymentReceipt(invoiceId))
    } else {
      console.log("Calling api for purchase");
      dispatch(deleteVendorPayment(invoiceId))
    }
    
    if(actionChangeHandler) {
      console.log("actionChangeHandler called to refresh the page")
      actionChangeHandler({ isRefersh: Math.random().toString()});
    }
    handleClose()
  };

  // Close thermal print dialog
  const handleCloseThermalDialog = useCallback(() => {
    setThermalPrintOpen(false);
    setSelectedInvoiceForPrint(null);
  }, []);

  return (
    <div>
      {showInlineAction ? 
      <>
        {row.status == "DRAFT" &&
        <>
          <IconButton onClick={(e) => handleEditInvoiceClick(row)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: 20 }}
            size='small'>
            <Tooltip arrow title={`Edit ${row.voucherType}`}><EditIcon color="info" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          <IconButton onClick={(e) => handleOpenShareDrawer(e, row.voucherType)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Share ${row.voucherType} ${row.status == 'DRAFT' ? '(Draft)': '(Published)'} `}><ShareIcon color="success" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          {(row.voucherType == VocuherTypes.PROFORMA_INVOICE || row.voucherType == VocuherTypes.ESTIMATE ) && 
            <>
              <IconButton onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.GST_INVOICE, row._id, VocuherTypes.ESTIMATE, false)}
                style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
                size='small'>
                <Tooltip arrow title={`Create Invoice from ${row.voucherType}`}><ContentCopyIcon color="warning" style={{ fontSize: 20 }} /></Tooltip>
              </IconButton>
            </>
          }
          <IconButton onClick={(e) => handleChangeInvoiceStatus(row._id, "PENDING")}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Mark as ${row.voucherCategory == VocuherCategory.PURCHASE ? 'Recieved': 'Sent'} `}><KeyboardDoubleArrowUpIcon style={{ fontSize: 20, color: "#2188ef" }} /></Tooltip>
          </IconButton>
        </>
        }
        {(row.status == "PENDING" || row.status == "Invoice Sent") &&
        <>
          <IconButton onClick={(e) => handleEditInvoiceClick(row)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Edit ${row.voucherType}`}><EditIcon color="info" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          <IconButton onClick={(e) => handleOpenShareDrawer(e, row.voucherType)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Share ${row.voucherType}`}><ShareIcon color="success" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          {(row.voucherType == VocuherTypes.PROFORMA_INVOICE || row.voucherType == VocuherTypes.ESTIMATE ) && 
            <>
              <IconButton onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.GST_INVOICE, row._id, VocuherTypes.ESTIMATE, false)}
                style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
                size='small'>
                <Tooltip arrow title={`Create Invoice from ${row.voucherType}`}><ContentCopyIcon style={{ fontSize: 20 }} /></Tooltip>
              </IconButton>
            </>
          }
          {(row.voucherCategory == VocuherCategory.SALE && 
            row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
            row.voucherType != VocuherTypes.ESTIMATE ) &&
            <IconButton onClick={(e) => openPaymentDrawer(e, row)}
              style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
              size='small'>
              <Tooltip arrow title={`Record Payment In`}><PaymentIcon style={{ fontSize: 20 }} /></Tooltip>
            </IconButton>
          }
          {/* {(row.voucherCategory == VocuherCategory.PURCHASE && 
            row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
            row.voucherType != VocuherTypes.ESTIMATE ) && 
            <IconButton onClick={(e) => openPaymentDrawer(e, row)}
              style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
              size='small' disabled>
              <Tooltip arrow title={`Record Payment Out`}><PaymentIcon style={{ fontSize: 20 }} /></Tooltip>
            </IconButton>
          } */}
        </>
        }
        {row.status == "PARTIALLY_PAID" &&
        <>
          <IconButton onClick={(e) => handleOpenShareDrawer(e, row.voucherType)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Share ${row.voucherType}`}><ShareIcon color="success" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          {(row.voucherCategory == VocuherCategory.SALE && 
            row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
            row.voucherType != VocuherTypes.ESTIMATE ) &&
            <IconButton onClick={(e) => openPaymentDrawer(e, row)}
              style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
              size='small'>
              <Tooltip arrow title={`Record Payment In`}><PaymentIcon style={{ fontSize: 20 }} /></Tooltip>
            </IconButton>
          }
          {/* {(row.voucherCategory == VocuherCategory.PURCHASE && 
            row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
            row.voucherType != VocuherTypes.ESTIMATE ) && 
            <IconButton onClick={(e) => openPaymentDrawer(e, row)}
              style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
              size='small'>
              <Tooltip arrow title={`Record Payment Out`}><PaymentIcon style={{ fontSize: 20 }} /></Tooltip>
            </IconButton>
          } */}
          {(row.voucherType != VocuherTypes.PROFORMA_INVOICE  ) && 
            <>
              <IconButton onClick={(e) => handleViewPaymentReceiptClick(row)}
                style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
                size='small'>
                <Tooltip arrow title={`View Receipts`}><ReceiptLongIcon style={{ fontSize: 20 }} /></Tooltip>
              </IconButton>
              <IconButton onClick={(e) => handleOpenShareDrawer(e, 'Payment Receipt')}
                style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
                size='small'>
                <Tooltip arrow title={`Share Receipts`}><ShareIcon color="success" style={{ fontSize: 20 }} /></Tooltip>
              </IconButton>
              <IconButton onClick={(e) => handleDeleteInvoicePayments(row._id, row.voucherCategory)}
                style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
                size='small'>
                <Tooltip arrow title={`Delete All Receipts`}><DeleteIcon color="error" style={{ fontSize: 20 }} /></Tooltip>
              </IconButton>
            </>
            }
        </>
        }
        {row.status == 'INVOICED' &&
          <>
            <IconButton onClick={(e) => handleViewInvoiceClick(row)}
              style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
              size='small'>
              <Tooltip arrow title={`Share ${row.voucherType}`}><ShareIcon color="success" style={{ fontSize: 20 }} /></Tooltip>
            </IconButton>
          </>
        }
        {(row.status == 'OVER_PAID' || row.status == 'PAID' ) &&
        <>
          <IconButton onClick={(e) => handleOpenShareDrawer(e, row.voucherType)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Share ${row.voucherType}`}><ShareIcon color="info" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          <IconButton onClick={(e) => handleViewPaymentReceiptClick(row)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`View Receipts`}><ReceiptLongIcon color="info" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          <IconButton onClick={(e) => handleOpenShareDrawer(e, 'Payment Receipt')}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Share Receipts`}><ShareIcon style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          <IconButton onClick={(e) => handleDeleteInvoicePayments(row._id, row.voucherCategory)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Delete All Receipts`}><ReceiptLongIcon color="error" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
        </>
        }
        {(row.voucherType && row.voucherCategory ) && 
          <IconButton onClick={(e) => handleNewTransaction(row.voucherCategory, row.voucherType, row._id, row.voucherType, true)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Make a copy`}><ContentCopyIcon style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
        }
        <IconButton onClick={(e) => handleThermalPrint(row)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Thermal Print ${row.voucherType}`}><LocalPrintshopIcon style={{ fontSize: 20, color: '#6b7280' }} /></Tooltip>
          </IconButton>
        </>
      :
        <>
        <Button
          variant="contained" size='small'
          style={{ marginRight: '10px', color:'#488dff',backgroundColor:'#fff',border:'1px solid #488dff',borderRadius:10 }}
          id="demo-customized-button"
          aria-controls={open ? 'demo-customized-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          disableElevation
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
        >
          Actions
        </Button>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            'aria-labelledby': 'demo-customized-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          
          {row.status == "DRAFT" &&
            <div>
            <MenuItem onClick={(e) => handleEditInvoiceClick(row)} disableRipple>
              <EditIcon color="primary"/>  
              Edit {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleViewInvoiceClick(row)} disableRipple>
              <PreviewIcon color='primary'/>  
              View {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleOpenShareDrawer(e, saleModuleType)} disableRipple>
              <ShareIcon color='primary'/>
              Share {saleModuleType} {row.status == "DRAFT"? '(Draft)': '(Published)'}
            </MenuItem>
            {(row.voucherType == VocuherTypes.PROFORMA_INVOICE || row.voucherType == VocuherTypes.ESTIMATE ) && 
              <>
                <MenuItem onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.GST_INVOICE, row._id, VocuherTypes.ESTIMATE, false)} disableRipple>
                  <ContentCopyIcon color='primary'/>
                  Create Invoice
                </MenuItem>
              </>
            }
            {(row.voucherCategory == VocuherCategory.PURCHASE && 
              row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
              row.voucherType != VocuherTypes.ESTIMATE ) && 
              <MenuItem onClick={(e) => openPaymentDrawer(e, row)} disableRipple>
                <PaymentIcon color='success'/>
                Record Payment Out
              </MenuItem>
            }
            <MenuItem onClick={(e) => handleChangeInvoiceStatus(row._id, "PENDING")} disableRipple>
              <DoneAllIcon color='primary' style={{color: "#2188ef"}}/>
              Mark as {row.voucherCategory == VocuherCategory.PURCHASE ? "Recieved ":"Sent"}
            </MenuItem>
            </div>
          }

          {(row.status == "PENDING" || row.status == "Invoice Sent") &&
            <div>
            <MenuItem onClick={(e) => handleEditInvoiceClick(row)} disableRipple>
              <EditIcon color="primary"/>  
              Edit {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleViewInvoiceClick(row)} disableRipple>
              <PreviewIcon color='primary'/>  
              View {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleOpenShareDrawer(e, saleModuleType)} disableRipple>
              <ShareIcon color='primary'/>
              Share {saleModuleType}
            </MenuItem>
            {(row.voucherType == VocuherTypes.PROFORMA_INVOICE || row.voucherType == VocuherTypes.ESTIMATE ) && 
              <>
                <MenuItem onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.GST_INVOICE, row._id, VocuherTypes.ESTIMATE, false)} disableRipple>
                  <ContentCopyIcon color='primary'/>
                  Create Invoice
                </MenuItem>
              </>
            }
            {(row.voucherCategory == VocuherCategory.SALE && 
              row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
              row.voucherType != VocuherTypes.ESTIMATE ) && 
              <MenuItem onClick={(e) => openPaymentDrawer(e, row)} disableRipple>
                <PaymentIcon color='success'/>
                Record Payment In
              </MenuItem>
            }
            {(row.voucherCategory == VocuherCategory.PURCHASE && 
              row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
              row.voucherType != VocuherTypes.ESTIMATE ) && 
              <MenuItem onClick={(e) => openPaymentDrawer(e, row)} disableRipple>
                <PaymentIcon color='success'/>
                Record Payment Out
              </MenuItem>
            }
            </div>
          }

          {row.status == "PARTIALLY_PAID" &&
            <div>
            <MenuItem onClick={(e) => handleViewInvoiceClick(row)} disableRipple>
              <PreviewIcon color='primary'/>  
              View {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleOpenShareDrawer(e, saleModuleType)} disableRipple>
              <ShareIcon color='primary'/>
              Share {saleModuleType}
            </MenuItem>
            {(row.voucherCategory == VocuherCategory.SALE && 
              row.voucherType != VocuherTypes.ESTIMATE ||
              row.voucherType != VocuherTypes.PROFORMA_INVOICE) && 
              <MenuItem onClick={(e) => openPaymentDrawer(e, row)} disableRipple>
                <PaymentIcon color='success'/>
                Record Payment In
              </MenuItem>
            }
            {(row.voucherCategory == VocuherCategory.PURCHASE && 
              row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
              row.voucherType != VocuherTypes.ESTIMATE ) && 
              <MenuItem onClick={(e) => openPaymentDrawer(e, row)} disableRipple>
                <PaymentIcon color='success'/>
                Record Payment Out
              </MenuItem>
            }
          
            {(row.voucherType != VocuherTypes.PROFORMA_INVOICE  ) && 
              <>
                <MenuItem onClick={(e) => handleViewPaymentReceiptClick(row)} disableRipple>
                  <ReceiptLongIcon color='primary'/>
                  View Receipts
                </MenuItem>
                <MenuItem onClick={(e) => handleOpenShareDrawer(e, 'Payment Receipt')} disableRipple>
                  <ShareIcon color='primary'/>
                  Share Receipts
                </MenuItem>
                <MenuItem onClick={(e) => handleDeleteInvoicePayments(row._id, row.voucherCategory)} disableRipple>
                  <DeleteIcon color='error' style={{color: '#e74c3c'}}/>
                  Delete All Receipts
                </MenuItem>
              </>
            }
            </div>
          }

          {row.status == 'INVOICED' &&
            <div>
              <MenuItem onClick={(e) => handleViewInvoiceClick(row)} disableRipple>
                <PreviewIcon color='primary'/>  
                View {saleModuleType}
              </MenuItem>
              <MenuItem onClick={(e) => handleOpenShareDrawer(e, saleModuleType)} disableRipple>
                <ShareIcon color='primary'/>
                Share {saleModuleType}
              </MenuItem>
            </div>
          }

          {(row.status == 'OVER_PAID' || row.status == 'PAID' ) &&
            <div>
            <MenuItem onClick={(e) => handleViewInvoiceClick(row)} disableRipple>
              <PreviewIcon color='primary'/>  
              View {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleOpenShareDrawer(e, saleModuleType)} disableRipple>
              <ShareIcon color='primary'/>
              Share {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleViewPaymentReceiptClick(row)} disableRipple>
              <ReceiptLongIcon color='primary'/>
              View Receipts
            </MenuItem>
            <MenuItem onClick={(e) => handleOpenShareDrawer(e, 'Payment Receipt')} disableRipple>
              <ShareIcon color='primary'/>
              Share Receipts
            </MenuItem>
            <MenuItem onClick={(e) => handleDeleteInvoicePayments(row._id, row.voucherCategory)} disableRipple>
              <DeleteIcon color='error' style={{color: '#e74c3c'}}/>
                Delete All Receipts
            </MenuItem>
            </div>
          }
  {/* 
          {row.status == "PARTIALLY_PAID" &&
            <div>
            <MenuItem onClick={(e) => handleInvoiceNoClick(row)} disableRipple>
              <PreviewIcon color='success' />  
              View Invoice
            </MenuItem>
            <MenuItem onClick={(e) => openPaymentDrawer(e, row)} disableRipple>
              <PaymentIcon color='success'/>
              Receive Payment
            </MenuItem>
            <MenuItem onClick={(e) => handleViewPaymentReceiptClick(row)} disableRipple>
              <ReceiptIcon color='primary'/>
              View Payment Receipt
            </MenuItem>
            </div>
            
          }

          {(row.status == 'OVER_PAID' || row.status == 'PAID' ) &&
            <div>
            <MenuItem onClick={(e) => handleInvoiceNoClick(row)} disableRipple>
              <PreviewIcon />  
              View Invoice
            </MenuItem>
            <MenuItem onClick={(e) => handleViewPaymentReceiptClick(row)} disableRipple>
              <ReceiptIcon />
              View Payment Receipt
            </MenuItem>
            </div>
          } */}
          
          <Divider sx={{ my: 0.5 }} />
          <div>
            {(row.voucherType && row.voucherCategory ) && 
              <>
                <MenuItem onClick={(e) => handleNewTransaction(row.voucherCategory, row.voucherType, row._id, row.voucherType, true)} disableRipple>
                  <ContentCopyIcon color='primary'/>
                  Make a copy
                </MenuItem>
              </>
            }
            <MenuItem onClick={(e) => handleThermalPrint(row)} disableRipple>
              <LocalPrintshopIcon style={{ color: '#6b7280' }}/>
              Thermal Print {saleModuleType}
            </MenuItem>
          {/* <MenuItem onClick={(e) => handleDeleteInvoice(row._id)} disableRipple disabled>
            <DeleteIcon style={{color:'#c33b3b'}}/>
            Delete {saleModuleType}
          </MenuItem> */}
          {/* <MenuItem onClick={handleClose} disableRipple disabled>
            <MoreHorizIcon />
            Coming Soon
          </MenuItem> */}
          </div>
          
        </StyledMenu>
        </>
      }

      <Drawer
          disableEscapeKeyDown={false}
          anchor="right"
          onClose={handleClosPaymentDrawer}
          open={openRecivePaymentDrawer}>
          <DialogRecievePaymentForm
              selectedInvoices={selectedInvoices}
              selectedBuyer={selectedBuyer}
              onClose={handleClosPaymentDrawer}
              open={openRecivePaymentDrawer}>
          </DialogRecievePaymentForm>
      </Drawer>

      <Drawer
        disableEscapeKeyDown={false}
        anchor="right"
        onClose={handleCloseShareDrawer}
        open={openShareDrawer}>
        <DialogShareInvoiceReciept
            dispatchType={shareType}
            invoiceId={saleId}
            invoicePreviewData={salePdfUrlLocation}
            onClose={handleCloseShareDrawer}
            selectedBuyer={selectedBuyer}
            openDrawer={openShareDrawer}>
        </DialogShareInvoiceReciept>
      </Drawer>
      {selectedInvoiceForPrint && (
        <ThermalPrintDialog
          open={thermalPrintOpen}
          onClose={handleCloseThermalDialog}
          invoice={selectedInvoiceForPrint}
          businessName={selectedAccount?.name || 'Business'}
          businessPhone={selectedAccount?.whatsAppNumber || ''}
          businessAddress={selectedAccount?.location?.address || ''}
        />
      )}
    </div>
  );
}


export default CustomizedEstimateMenus;
